import { useHistory, generatePath } from 'react-router-dom'
import { encodeQueryString, haAlmenoUnaChiave, useRoutes } from '@lucan/base-ui'

export default function useNavigate() {
  const history = useHistory()

  const { getPath } = useRoutes()

  function navigate(chiaveRotta, params, queryParams) {
    let pathRotta = getPath(chiaveRotta)
    if (haAlmenoUnaChiave(params)) {
      pathRotta = generatePath(pathRotta, params)
    }
    if (haAlmenoUnaChiave(queryParams)) {
      pathRotta += `?${encodeQueryString(queryParams)}`
    }
    history.push(pathRotta)
  }

  return { navigate }
}